module.exports = __webpack_public_path__ + "static/b3-2a903c95c250890b8ca3624d670de296.jpg";